
evite.when('block js').then(function(){
  $('.group-loader').each(function(index, root){
    var $root  = $(root);
    var $images = $root.find('img[data-src]');

    let loadingAssets;
    if(!$images.length){
      loadingAssets = Promise.resolve();
    }
    else {
      $root.addClass('group-loader-loading');
      loadingAssets = loadImages($images)
    }

    loadingAssets
      .then(function(){
        $root.removeClass('group-loader-loading');
        $root.addClass('group-loader-complete');
      })
      .catch(function(){
        $root.removeClass('group-loader-loading');
        $root.addClass('group-loader-failed');
      });
  });


  function loadImages($images){
    var pendingAssets = [];

    $images.each(function(index, element){
      var $elem = $(element);
      var src = $(element).attr('data-src');

      var promise = fetchImage(src);
      promise.then(function(){
        $elem.attr('src', src);
      });

      pendingAssets.push(promise);
    });

    return Promise.all(pendingAssets);
  }

  function fetchImage(src){
    return new Promise(function(resolve, reject){
        var image = new Image();
        $(image)
          .load(resolve)
          .error(reject)
          .attr('src', src);
    });
  }
});



// WEBPACK FOOTER //
// ./assets/es6/common/evite_group_loader.es6